(function(){
    "use strict";

    angular
        .module('pwc.controllers')
        .controller('VersionDialogController', VersionDialogController);

    VersionDialogController.$inject = ['$mdDialog', '$window', 'UserStore'];

    function VersionDialogController($mdDialog, $window, UserStore) {

        /* jshint validthis: true */
        var self = this;

        self.hasPendingChanges = UserStore.state.hasPendingChanges;

        self.close = close;
        self.update = update;

        function close(){
            $mdDialog.hide();
        }

        function update(){
            // performing a full reload will get the latest html which will have the latest build number
            $window.location.reload();
        }

    }

})();